import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { ShowleftDirective } from '../../../directives/animations/showleft.directive';
import { ShowrightDirective } from '../../../directives/animations/showright.directive';

@Component({
  selector: 'section[app-about-craft-section]',
  imports: [
    NgOptimizedImage,
    ShowleftDirective,
    ShowrightDirective,
  ],
  templateUrl: './about-craft-section.html',
  styleUrl: './about-craft-section.scss',
})
export class AboutCraftSection {
}
